import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import actions from "./actions";

// get dashboard logs
function* getDashboardLogsSaga({
  payload: { page, limit, fromDate, toDate, level, method, search },
}) {
  //console.log("Saga called with:", { page, limit, fromDate, toDate, level, method, search });
  try {
    const response = yield call(
      axios.get,
      `http://localhost:7070/logs?page=${page}&limit=${limit}${search ? `&search=${search}` : ""}${fromDate ? `&fromDate=${fromDate}` : ""}${toDate ? `&toDate=${toDate}` : ""}${level ? `&level=${level}` : ""}${method ? `&method=${method}` : ""}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      }
    );
    //console.log("Logs fetched:", response.data);
    if(response.status !== 200) {
      yield put(actions.getDashboardLogsFailure('Failed to fetch logs'));
      throw new Error('Failed to fetch logs');
    }
    yield put(actions.getDashboardLogsSuccess(response.data));
  } catch (error) {
    yield put(actions.getDashboardLogsFailure(error.message));
  }
}

export default function* dashboardLoggerSaga() {
  yield takeLatest("GET_DASHBOARD_LOGS", getDashboardLogsSaga);
}
